
function RampOptions() {
    /// <summary>
    /// <br/>
    /// Author: ARF<br />
    /// Date: 2.11.2015<br />
    /// Copyright ©: EUDT GmbH 2015 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.3 - 6.6.2016                                               *<br />
    /// **********************************************************************<br />
    /// * - in large-theme added top and bottom margin                       *<br />
    /// **********************************************************************<br />
    /// *** v1.0.2 - 09.3.2016                                               *<br />
    /// **********************************************************************<br />
    /// * - (MWI) style for fonts set                                         *<br />
    /// **********************************************************************<br />
    /// *** v1.0.1 - 17.2.2016                                               *<br />
    /// **********************************************************************<br />
    /// * - intervention list adopted to shortened tooltips                  *<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 2.11.2015                                               *<br />
    /// **********************************************************************<br />
    /// * - extracted ramp chart settings                                    *<br />
    /// **********************************************************************<br />
    /// </summary>
    //get set serverside
    this.deviceType = -1;


    this.theme = {
        chart: {
           
            defaultSeriesType: 'spline',
            bordercolor: '#fff',
            borderWidth: 0,
            borderRadius: 0,
            backgroundColor: '#fff',
            plotBackgroundColor: null,
            plotBorderWidth: 0,
            spacingTop: 15,
            spacingBottom: 10,
            spacingRight: 5,
            spacingLeft: 0,
            style: { fontFamily: "Verdana, helvetica, arial", fontSize: "11px" }
        },
        title: { text: "" },
        exporting: {
            enabled: false,
            allowHTML: true,
            showTable: false,
            tableDecimalPoint: ",", // "." or ","
            tableDecimalValue: 2,
            menuItemDefinitions: {
                // Custom definition
                preview: {
                    text: '--PREVIEW VERSION--'
                }
            },
            buttons: { contextButton: {
                menuItems: ['preview','separator',
                    {
                    textKey: 'viewData',
                    text: 'Show/hide data table',
                    onclick: function () {
                        if (this.dataTableDiv && this.dataTableDiv.style.display !== 'none') {
                            this.dataTableDiv.style.display = 'none';
                          
                        } else {
                           // this.viewData();
                            this.dataTableDiv.style.display = '';

                        }
                    }
                    },

                    'separator','downloadJPEG', 'downloadPNG', 'downloadPDF', 'separator', 'downloadCSV', 'viewFullscreen'],
                x: -6
            } },
            chartOptions: {
                //data: {decimalPoint:','},
                credits: {
                    enabled: true, position: {align:"left"} },
                legend: {
                    x: 10,
                    y: 0,
                    margin: 10,
                    itemMarginBottom: 5,
                    symbolWidth: 20,
                    symbolHeight: 10,
                    symbolPadding: 3,
                    squareSymbol: true
                }
            },
            fallbackToExportServer: true,
            useMultiLevelHeaders:false

        },
        legend: {
            useHTML: false,
            verticalAlign: 'bottom',
            align: 'center',
            layout: 'horizontal',
            title: { style: { 'fontWeight': 'normal' } },
            borderWidth: 0,
            padding: 0,
           
            margin: 5,
            itemStyle: {
                cursor: 'pointer',
                color: '#333333'
            }
        },

        plotOptions: {
            spline: {
                shadow: false,
                marker: { radius: 5 },
                states: { hover: { enabled: true } }
            },
            area: { states: { hover: { enabled: true, opacity: 0.25 } } },
            column: {pointPadding:0.05,groupPadding:0.05, states: { hover: { enabled: true } } }
        },
        tooltip: {
            enabled: true,
            useHTML: true,
            crosshairs: [true, true]
        },
        xAxis: {
            title: { text: '' },
            lineColor: '#555555',
          
            tickColor: '#555555',
            lineWidth: 1,
            tickWidth: 1,
            showLastLabel: true,
            startOnTick: true,
            // endOnTick: true,

            labels: {
                step: null,
              
                style: {
                    color: '#555555',
                    font: '11px Verdana, helvetica, arial'
                }
            }
        },
        yAxis: {
            title: {},
            lineColor: '#555555',
            tickColor: '#555555',
            lineWidth: 1,
            tickWidth: 1,
           
            showFirstLabel: true,
            minorTickInterval: null,

            alternateGridColor: '#f8f8f8',
            offset: 0,
            labels: {
                y: 4,
                style: {
                    color: '#555555',
                    font: '11px Verdana, helvetica, arial'
                }
            }
        }
    };

    this.themeSmall = Highcharts.merge(this.theme,
        {
            chart: {
                marginTop:10,
                backgroundColor: '#ffffff',
                style: { fontSize: "6px" }

            },
            plotOptions: {
                spline: {
                    lineWidth: 2,
                    marker: { radius: 3 }
                }
            },
            tooltip: {
                style: { fontSize: "6px" }
            },
            legend: {
                backgroundColor: '#FFFFFF',
                itemStyle: {
                    font: '6px Verdana, helvetica, arial'
                }
            },
            xAxis: {
                lineWidth: 1,
                tickWidth: 1,
                labels: { style: { font: '6px Verdana, helvetica, arial' } }
            },
            yAxis: {
                lineWidth: 1,
                tickWidth: 1,
                tickInterval: 4,
                labels: { style: { font: '6px Verdana, helvetica, arial'  } }
            }
        });


    this.themeLarge = Highcharts.merge(this.theme,
    {
        chart: {
            marginTop: 20,
            backgroundColor: '#ffffff'

        },
        plotOptions: {
            spline: {
                lineWidth: 3
            }
        },
        legend: {
            itemMarginTop: 15,
            backgroundColor: '#FFFFFF',
            itemStyle: {
                font: '13px Verdana, helvetica, arial'
            }
        },
        xAxis: {
            labels: { style: { font: '13px Verdana, helvetica, arial' } }
        },
        yAxis: {
            labels: { style: { font: '13px Verdana, helvetica, arial' } }
        }
    });

    this.showInterventions = function (chart, e) {
        var me = this;
       var i,j,list,data,seriesID,bFound,bShow,legend = '',yAxisIndex = -1;
        //get the intervention list
       list = e.point.n.interventionlist;
        //if we use only a simple legend without html - we show all interventions in a popup and stop after it'
        if (this.simpleLegend) {
            if (this.deviceType === 2 && this.mobile) {
                legend = "<div style='font-size:16px'>";
            } else {
                legend = "<div style='font-size:12px'>";
            }
            
            legend += "<div class='tblHeader' style='margin-bottom:10px'>" + me.resources.intervention + "</div>";
            for (i = 0; i < list.length; i++) {
                legend += this.showInterventionEntry(list[i], e);
                legend += "<hr/>";
            }
            legend += "</div>";

            var divHolder = $("<div>").attr("id", "treeHolder").css({
                overflow: "hidden", height: "600px", width: "400px","background-color":"#fff"
        });
            me.dialog = $("<div>").attr("id", "infoDialog").css({ display: "none" });
            me.dialog.appendTo(divHolder);
            me.dialog.dialog({
                autoOpen: false,
                modal: true,
                resizable: false,
                width: 400,
                dialogClass: "saveDialog",
                title: me.resources.intervention,
                buttons: {
                    Ok: function () {
                        $(this).dialog("close");
                    }
                }
            });
            divHolder.appendTo(this.visual);
           
           // $("<div>").attr("id", "btnHelp").html(settings.resources.help).button({ disabled: false }).appendTo(divTop).off("click").on("click", function () {
            me.dialog.html(legend).dialog("open");
            //});





          //  showModalPopup(legend, this.width, this.height+100);
            return true;
        }

        //get the index of the yAxis of the given series
            //we need it to add the new series to the same axis
        for (i = 0; i < chart.yAxis.length; i++) {if (chart.yAxis[i] === e.point.series.yAxis) { yAxisIndex = i}}

            //first, find any visible intervention series
            //if we find at least one we hide all series on the icon click
            bShow = true;
           for (i = 0; i < list.length; i++) {
              seriesID = e.point.series.name.n + '__Intervention_' + e.point.n.bsaid + '_' + list[i].id;
              for (j = 0; j < chart.series.length; j++) {
                if (typeof (chart.series[j].name.id) != 'undefined') {
                  if (chart.series[j].name.id === seriesID) {
                    if (chart.series[j].visible === true) {bShow = false;}
                  }
                }
              }
            }

                //we reset the start and end indexes for single day interventions
                //as an area for one single day is not visible we add one more day to get it shown
            for (i =0; i<list.length; i++) {
              if (list[i].end === -1) {list[i].end = e.point.series.data.length-1;}
              if (list[i].start === list[i].end) {
                if (list[i].end < (e.point.series.data.length-1)) {
                  list[i].end++;
                } else {
                  list[i].start--;
                }
              }
                //for interventions which already started in the past we set the start point to the first series point index.
              if (list[i].type === 0) {list[i].start = 0;}

                //now let's fill the data array for all values which are between the start and end index 
              data = new Array;
              for (j = 0; j < e.point.series.data.length; j++) {
                if ((j >= list[i].start) && j <= (list[i].end)) {
                  data.push(e.point.series.data[j].y);
                } else {
                  data.push(null);
                }
              }
              //build an unique id
              seriesID = e.point.series.name.n + '__Intervention_'+e.point.n.bsaid + '_' + list[i].id;
              bFound = false;
                //if we have already added the series before we just show/hide it
              for (j = 0; j < chart.series.length; j++) {
                if (typeof(chart.series[j].name.id) != 'undefined') {
                  if (chart.series[j].name.id === seriesID) {
                    if (bShow===false) {
                      chart.series[j].hide();chart.series[j].update({ showInLegend: false });
                    } else {
                      chart.series[j].show();chart.series[j].update({ showInLegend: true });
                    }
                    bFound = true;
                  }
                }
              }
              //if we haven't added the series we add a new one. 
              if (bFound === false) {

                  legend = this.showInterventionEntry(list[i], e);

                chart.addSeries({
                      type: 'areaspline',lineWidth: 0,fillOpacity: 0.15,connectNulls: true,threshold: null,
                      showInLegend: true, marker: { enabled: false },name: { id: seriesID, sn: legend, bg: '#eee',
                    //this flag is used to deactivate the tooltip for interventions
                     isIntervention:true },
                      yAxis: yAxisIndex, data : data
                }, false);
              }
            }

            chart.redraw();
            return true;
    }

    this.showInterventionEntry = function (entry, e) {
        var legend;
        legend = "<div style='white-space:normal'><img style='height:12px' src='../../images/intervention.png'/> <u>" + entry.interventionType + ":</u><br/>" + entry.name;
        legend += "<br/><u>" + this.resources.signal + "</u>:<br/>" + e.point.series.name.n + "<br/><u>" + this.resources.periodOfTime + "</u>:<br/>" + entry.legendInterval;
        if (entry.description.length > 0) { legend += "<br/><u>" + this.resources.description + "</u>:<br/>" + entry.description; }
        if (entry.task.length > 0) { legend += "<br/><u>" + this.resources.measure + "</u>:<br/>" + entry.task; }
        legend += "</div>";

        return legend;

    }

}




RampOptions.prototype = new vcTemplate();



RampOptions.prototype.setGlobalOptions = function(langId) {
    var me = this;
  
    switch (langId) {
        case 2: //translate to german

            Highcharts.setOptions({
                lang: {
                    contextButtonTitle: 'Export Menü',

                    downloadJPEG: 'JPEG generieren',
                    downloadPDF: 'PDF generieren',
                    downloadPNG: 'PNG generieren',
                    downloadSVG: 'Download SVG',
                    downloadXLS: 'XLS-Export',
                    downloadCSV: 'CSV-Export',
                    printChart: 'Chart drucken'
                }
            });
            break;
    default:
    }

}



RampOptions.prototype.getTheme = function () {

    var me = this;
    try {
        if (me.error) {
            return false;
        }
        if (parseInt(me.deviceType, 10) < 2) {
            //net and TV
            return me.theme;
        } else {
            //mobile
            if (me.width < 660) {
                return me.themeSmall;
            } else {
                return me.themeLarge;
            }
        }
        //switch (parseInt(me.deviceType, 10)) {
        //    case 1: //net 
        //        return me.theme;
              

             
        //    case 2: //TV
        //        //return me.themeLarge;
        //        return me.theme;
        //    case 3: //mobile
        //        if (me.width < 660) {
        //            return me.themeSmall;
        //        } else {
        //            return me.theme;
        //        }
        //}
        return me.theme;
    } catch (ex) {
        me.writeError('getTheme', ex);
        return false;
    }

};


RampOptions.prototype.generateExportColHeader = function(item) {
    if (!item || item instanceof Highcharts.Axis) {
    } else {

        var name = $("<div>" + item.name.sn + "</div>");
        name.find("i").remove();
        name.find("br").remove();
        var x = name.find("span");
        name.find("span").remove();
        return name.html() + ' (' + x.html() + ')';

    }
    return "";
}
